import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICategory } from '@app/models/category.interface';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  public endpoint:string = environment.apiUrl + '/categories';
  public currentCategoryData$: State<number>;
  public currentCategory$: Observable<any>;
  
  constructor(private http: HttpClient, private _matSnackbar:  MatSnackBar, private store$: Store) {

  }

  public getCategories():Observable<any>{
    return this.http.get<any>(this.endpoint);
  }

  public update(category, id){
    return this.http.put<any>(`${this.endpoint}/${id}`, category);
  }

  public add(area){
    return this.http.post<any>(`${this.endpoint}`, area);
  }

  public onDelete(id:number){
    return this.http.delete<any>(`${this.endpoint}/${id}`)
  }

  public getCategoryWithProducts(): Observable<any>{
    return this.http.get<any>(`${this.endpoint}/products/categories`);
  }

  public onSortCategoriesOrg(products){
    return this.http.patch(`${this.endpoint}/sort`,{
      products
    }).pipe(first()).subscribe(item => {
    })
  }

  public onSortCategories(products): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Content-type', 'application/json');
    return this.http.patch(`${this.endpoint}/sort/products/${products[0].prdCatID}`,{
      products
    }, {
      headers
    });
  }

  public onSortCategoriesByName(prdCatID): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Content-type', 'application/json');
    return this.http.patch(`${this.endpoint}/sort/products/name/${prdCatID}`, {
      headers
    });
  }
}
